<div class="p-4 flex flex-col md:p-14 gap-[1rem] mt-2">
  <!-- Loader inicial: cliente entrando al home, todavía no sabemos si
       está bloqueado. Evita mostrar el dashboard normal por unos ms
       cuando en realidad debería ver el embed bloqueante. -->
  <div
    *ngIf="userRole === userEnum.aguacate_client && !statusInitialized"
    class="dur-home-loader"
  >
    <mat-spinner diameter="40"></mat-spinner>
    <span>Cargando tu cuenta...</span>
  </div>

  <!-- Fallback defensivo: bloqueado=true pero el backend no devolvió
       requestId. No podemos cargar el form, así que damos un camino
       claro hacia soporte. -->
  <div
    *ngIf="userRole === userEnum.aguacate_client && statusInitialized && shouldShowBlockedFallback"
    class="dur-home-fallback"
  >
    <mat-icon>support_agent</mat-icon>
    <h2>Necesitamos validar algo en tu cuenta</h2>
    <p>
      Tu cuenta tiene una restricción temporal. Para resolverlo rápido,
      contactá a nuestro equipo de soporte y te ayudamos en pocos minutos.
    </p>
    <button class="dur-home-fallback__btn" (click)="openWhatsAppSupport()">
      <mat-icon>chat</mat-icon>
      Hablar con soporte por WhatsApp
    </button>
  </div>

  <!-- Banner CTA: cliente tiene solicitud de actualización abierta.
       Le mostramos un aviso llamativo al top del home con botón que
       navega al form dedicado. El dashboard normal se ve debajo así el
       cliente puede consultar sus datos. El bloqueo HTTP sigue activo
       vía el interceptor (los botones operativos van a rebotar). -->
  <div
    *ngIf="userRole === userEnum.aguacate_client && statusInitialized && shouldShowValidationBanner"
    class="dur-validation-cta"
    role="alert"
  >
    <div class="dur-validation-cta__icon">
      <mat-icon>assignment_late</mat-icon>
    </div>
    <div class="dur-validation-cta__text">
      <strong>Es requerido completar una validación de datos</strong>
      <span>
        Necesitamos actualizar algunos datos de tu cuenta para que puedas
        seguir operando con normalidad. Es rápido y seguro.
      </span>
    </div>
    <button
      type="button"
      class="dur-validation-cta__btn"
      (click)="goToValidationForm()"
    >
      <mat-icon>edit_note</mat-icon>
      Completar validación
    </button>
  </div>

  <ng-container *ngIf="userRole === userEnum.aguacate_client && statusInitialized">
    <!-- Acceso suspendido por revisión (PRE bloqueado): no habilita operar,
         pero el CTA de completar registro sigue disponible más abajo. -->
    <div *ngIf="cupoBloqueado"
      style="margin: 0 0 20px; border: 1px solid #fecaca; background: #fef2f2; border-radius: 16px; padding: 14px 18px; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #dc2626;">gpp_maybe</mat-icon>
      <span style="color: #991b1b; font-weight: 600; font-size: 0.9rem;">
        Tu acceso está suspendido por revisión de compliance.
      </span>
    </div>

    <ng-container *ngIf="estadoValidacion === 2">
      <!-- Greeting -->
      <div style="margin-bottom: 24px;">
        <h1 style="font-size: 1.35rem; font-weight: 800; color: #1f2937; margin: 0;">
          Hola, <span style="color: #1e5a3f;">{{ user.nombre }}</span>
        </h1>
        <p style="font-size: 0.85rem; color: #6b7280; margin-top: 4px;">Bienvenido a tu billetera Aguacate</p>
      </div>

      <!-- Banner de cupo pre-aprobado (PRE con tope vigente) -->
      <div *ngIf="cupoAplicaTope"
        style="margin-bottom: 20px; border: 1px solid #fde68a; background: #fffbeb; border-radius: 16px; padding: 16px 18px;">
        <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; margin-bottom: 8px;">
          <span style="display: inline-flex; align-items: center; gap: 8px; color: #92400e; font-weight: 700; font-size: 0.92rem;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px;">verified_user</mat-icon>
            Acceso aprobado
          </span>
          <span style="font-weight: 800; font-size: 1.05rem;" [style.color]="cupoBarColor">{{ cupoPorcentaje }}%</span>
        </div>
        <div style="height: 10px; border-radius: 999px; background: #f3f4f6; overflow: hidden;">
          <div [style.width.%]="cupoPorcentaje > 100 ? 100 : cupoPorcentaje" [style.background]="cupoBarColor"
            style="height: 100%; border-radius: 999px; transition: width 0.3s ease;"></div>
        </div>
        <p style="margin: 8px 0 0; font-size: 0.82rem; color: #78350f;">
          Has usado <strong>${{ formatCupoClp(cupoMe?.consumido) }}</strong>
          de <strong>${{ formatCupoClp(cupoMe?.tope) }}</strong>
          · Disponible <strong>${{ formatCupoClp(cupoMe?.disponible) }}</strong>
        </p>
        <p style="margin: 4px 0 0; font-size: 0.8rem; color: #92400e;">
          Estás operando con acceso pre-aprobado. Completa tu registro para operar sin límite.
        </p>
      </div>

      <!-- CTA para completar el registro (empresa aún no aprobada) -->
      <div *ngIf="registroPendiente && isCompany === 1 && !hasPendingUpdate"
        style="margin-bottom: 20px; border: 1px solid #bbf7d0; background: #f0fdf4; border-radius: 16px; padding: 14px 18px; display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap;">
        <span style="display: inline-flex; align-items: center; gap: 8px; color: #166534; font-weight: 600; font-size: 0.88rem;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px;">assignment_turned_in</mat-icon>
          Completa tu registro para operar sin límite
        </span>
        <button routerLink="/wallet/client/company-registration"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 9px 18px; border: none; border-radius: 10px; background: #1e5a3f; color: white; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
          Completar registro
        </button>
      </div>

      <!-- Balance Cards -->
      <div class="flex flex-col sm:flex-row gap-4" style="margin-bottom: 24px;">

        <!-- CLP Balance Card -->
        <div *ngIf="tipoId !== 'VE'" class="w-full sm:w-auto sm:flex-1" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; max-width: 380px;">
          <div style="background: linear-gradient(135deg, #1C593D, #16a34a); padding: 14px 18px; display: flex; align-items: center; gap: 10px;">
            <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <img src="assets/flags/chile.png" alt="CLP" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
            </div>
            <span style="color: white; font-weight: 700; font-size: 0.9rem;">Saldo CLP</span>
          </div>
          <div style="padding: 20px 18px;">
            <p style="font-size: 1.75rem; font-weight: 800; color: #1f2937; margin: 0; line-height: 1.2;">
              ${{ saldoActual | customNumberPipe }}
            </p>
            <p style="font-size: 0.78rem; color: #6b7280; margin-top: 4px;">Saldo Actual</p>

            <!-- Línea de crédito activa -->
            <div *ngIf="lineaCredito && lineaCredito > 0 && !lineaCreditoBloqueada"
              style="margin-top: 16px; padding-top: 14px; border-top: 1px solid #e5e7eb;">
              <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 10px;">
                <span style="font-size: 0.78rem; color: #6b7280;">Saldo Contable</span>
                <span style="font-size: 1rem; font-weight: 700; color: #1f2937;">${{ saldoContable | customNumberPipe }}</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: baseline;">
                <span style="font-size: 0.78rem; color: #6b7280;">Sobregiro Disponible</span>
                <span style="font-size: 1rem; font-weight: 700; color: #16a34a;">${{ sobregiroDisponible | customNumberPipe }}</span>
              </div>
            </div>

            <!-- Línea de crédito bloqueada -->
            <div *ngIf="lineaCredito && lineaCredito > 0 && lineaCreditoBloqueada"
              style="margin-top: 16px; padding-top: 14px; border-top: 1px solid #e5e7eb;">
              <div style="display: flex; align-items: center; gap: 6px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; margin-bottom: 12px;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">warning</mat-icon>
                <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;">Su línea de crédito se encuentra actualmente bloqueada</span>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: baseline;">
                <span style="font-size: 0.78rem; color: #6b7280;">Sobregiro Bloqueado</span>
                <span style="font-size: 1rem; font-weight: 700; color: #dc2626;">${{ sobregiroDisponible | customNumberPipe }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- VES Balance Card (VE, y chilenos con saldo VES junto al CLP). Se
             pinta en el lugar de cada uno: el VE la ve antes del USDT (es su
             moneda) y el chileno después, CLP → USDT → VES. Solo el saldo,
             como las otras: las opciones VES del chileno están en los modales
             de Recargar y Retirar. -->
        <ng-template #tarjetaVes>
        <div class="w-full sm:w-auto sm:flex-1" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; max-width: 380px;">
          <div style="background: linear-gradient(135deg, #1C593D, #16a34a); padding: 14px 18px; display: flex; align-items: center; gap: 10px;">
            <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <img src="assets/flags/venezuela.png" alt="VES" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
            </div>
            <span style="color: white; font-weight: 700; font-size: 0.9rem;">Saldo VES</span>
          </div>
          <div style="padding: 20px 18px;">
            <p style="font-size: 1.75rem; font-weight: 800; color: #1f2937; margin: 0; line-height: 1.2;">
              Bs. {{ saldoVes | customNumberPipe }}
            </p>
            <p style="font-size: 0.78rem; color: #6b7280; margin-top: 4px;">Saldo Disponible</p>
          </div>
        </div>
        </ng-template>
        <ng-container *ngIf="tipoId === 'VE'" [ngTemplateOutlet]="tarjetaVes"></ng-container>

        <!-- USDT Balance Card -->
        <div class="w-full sm:w-auto sm:flex-1" style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; max-width: 380px;">
          <div style="background: linear-gradient(135deg, #1e5a3f, #059669); padding: 14px 18px; display: flex; align-items: center; gap: 10px;">
            <div style="width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 22px; height: 22px; border-radius: 50%; object-fit: cover;">
            </div>
            <span style="color: white; font-weight: 700; font-size: 0.9rem;">Saldo USDT</span>
          </div>
          <div style="padding: 20px 18px;">
            <p style="font-size: 1.75rem; font-weight: 800; color: #1f2937; margin: 0; line-height: 1.2;">
              ${{ saldoUsdtDisponible | customNumberPipe }}
            </p>
            <p style="font-size: 0.78rem; color: #6b7280; margin-top: 4px;">Saldo Disponible</p>
          </div>
        </div>

        <!-- VES del chileno con saldo VES: después del USDT -->
        <ng-container *ngIf="esChilenoConVes" [ngTemplateOutlet]="tarjetaVes"></ng-container>

      </div>
      <!-- Tasas del día por país. Se refresca sola cada 3 minutos; se pliega
           desde su encabezado y recuerda el estado por usuario. -->
      <app-home-rates></app-home-rates>

      <!-- Campaña de referidos. Se dibuja sola: si el programa está apagado o
           al cliente ya no le queda cupo, no ocupa ni una línea. Nace plegada,
           igual que las tasas. -->
      <app-referidos-home></app-referidos-home>

      <h2 style="font-size: 1.1rem; font-weight: 700; color: #1f2937; margin: 0 0 16px;">
        ¿Qué deseas realizar hoy?
      </h2>
      <!-- Botones Chile -->
      <div *ngIf="tipoId !== 'VE'" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6" style="gap: 10px; margin-bottom: 24px;">

        <!-- Comprar USDT -->
        <button type="button" routerLink="/wallet/client/send-cripto" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #f0fdf4; display: flex; align-items: center; justify-content: center;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;">
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Comprar USDT</span>
        </button>

        <!-- Vender USDT -->
        <button type="button" routerLink="/wallet/client/convert-usdt-clp" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #eff6ff; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #2563eb;">currency_exchange</mat-icon>
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Vender USDT</span>
        </button>

        <!-- Enviar Remesa — cotizador unificado. Reemplaza al modal viejo:
             mismo nombre e ícono, pero entra directo a /client/enviar. -->
        <button type="button" routerLink="/wallet/client/enviar" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; display: flex; align-items: center; justify-content: center;">
            <img src="assets/img/remesa-verde.png" alt="Enviar Remesa" style="width: 28px; height: 28px; object-fit: contain;">
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Enviar Remesa</span>
        </button>

        <!-- Enviar Zelle -->
        <button type="button" routerLink="/wallet/client/zelle-home" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #faf5ff; display: flex; align-items: center; justify-content: center;">
            <img src="assets/icons/zelle.png" alt="Zelle" style="width: 28px; height: 28px; object-fit: contain;">
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Enviar Zelle</span>
        </button>

        <!-- Recargar -->
        <button type="button" (click)="openRechargeModal()" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #f0fdf4; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #16a34a;">download</mat-icon>
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Recargar</span>
        </button>

        <!-- Retirar -->
        <button type="button" (click)="openRetiroModal()" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #fff7ed; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #ea580c;">upload</mat-icon>
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Retirar</span>
        </button>

      </div>

      <!-- Botones Venezuela -->
      <div *ngIf="tipoId === 'VE'" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6" style="gap: 10px; margin-bottom: 24px;">

        <!-- Conversiones USDT/VES -->
        <button type="button" (click)="openConversionVeModal()" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #f0fdf4; display: flex; align-items: center; justify-content: center;">
            <img src="assets/icons/USDT_Logo.png" alt="USDT" style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;">
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Conversiones</span>
        </button>

        <!-- Enviar Remesa VE — cotizador unificado (mismo nombre e ícono
             que el botón viejo, sin el modal intermedio). -->
        <button type="button" routerLink="/wallet/client/enviar" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; display: flex; align-items: center; justify-content: center;">
            <img src="assets/img/remesa-verde.png" alt="Enviar Remesa" style="width: 28px; height: 28px; object-fit: contain;">
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Enviar Remesa</span>
        </button>

        <!-- Recargar VE -->
        <button type="button" (click)="openRechargeVeModal()" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #f0fdf4; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #16a34a;">download</mat-icon>
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Recargar</span>
        </button>

        <!-- Retirar VE -->
        <button type="button" (click)="openRetiroVeModal()" class="action-card"
          style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 16px 8px; background: white; border: 1px solid #e5e7eb; border-radius: 14px; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 48px; height: 48px; border-radius: 14px; background: #fff7ed; display: flex; align-items: center; justify-content: center;">
            <mat-icon style="font-size: 26px; width: 26px; height: 26px; color: #ea580c;">upload</mat-icon>
          </div>
          <span style="font-size: 0.75rem; font-weight: 700; color: #1e5a3f; text-align: center; line-height: 1.2;">Retirar</span>
        </button>

      </div>

      <!-- Historial de Transacciones VES / USDT -->
      <ng-container *ngIf="tipoId === 'VE'">
        <div style="padding: 16px 0; max-width: 100%; box-sizing: border-box;">
          <div class="flex items-center gap-3" style="margin-bottom: 20px;">
            <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px; flex-shrink: 0;">receipt_long</mat-icon>
            <div>
              <h1 style="font-size: 1.4rem; font-weight: 700; color: #1f2937; margin: 0;">Historial de Transacciones</h1>
              <p style="font-size: 0.8rem; color: #6b7280; margin: 2px 0 0;">Consulta tus operaciones</p>
            </div>
          </div>

          <mat-tab-group class="historial-tabs">
            <!-- Tab VES -->
            <mat-tab label="VES">
              <!-- Paginador -->
              <mat-paginator
                *ngIf="totalMovimientosVes > 0"
                [length]="totalMovimientosVes"
                [pageSize]="pageSizeVes"
                [pageSizeOptions]="[10, 20, 50]"
                [pageIndex]="currentPageVes - 1"
                (page)="onPageChangeVes($event)"
                showFirstLastButtons
                aria-label="Seleccionar pagina de movimientos VES"
                style="margin-bottom: 12px; margin-top: 12px;">
              </mat-paginator>

              <!-- Loading -->
              <div *ngIf="loadingVes" style="text-align: center; padding: 48px 20px;">
                <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
                <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando movimientos...</p>
              </div>

              <!-- Cards de movimientos VES -->
              <div class="flex flex-col gap-3" *ngIf="!loadingVes" style="margin-top: 12px; overflow: hidden; min-width: 0;">
                <div *ngFor="let mov of movimientosVes; let i = index"
                  style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">

                  <!-- Header row -->
                  <div (click)="expandedVesIndex = expandedVesIndex === i ? null : i"
                    style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer; overflow: hidden;"
                    [style.background]="expandedVesIndex === i ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

                    <!-- Icon credito/debito -->
                    <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
                      [style.background]="mov.creditVes > 0 ? '#f0fdf4' : '#fef2f2'">
                      <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
                        [style.color]="mov.creditVes > 0 ? '#16a34a' : '#dc2626'">
                        {{ mov.creditVes > 0 ? 'south_west' : 'north_east' }}
                      </mat-icon>
                    </div>

                    <!-- Info central -->
                    <div style="flex: 1; min-width: 0; overflow: hidden;">
                      <div style="font-weight: 700; font-size: 0.85rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{ sanitizeVesDescription(mov) }}
                      </div>
                      <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
                        {{ mov.createdAt | date:'medium' }}
                      </div>
                      <!-- Monto inline en mobile -->
                      <div style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                        <span style="font-weight: 700; font-size: 0.85rem;"
                          [style.color]="mov.creditVes > 0 ? '#16a34a' : '#dc2626'">
                          {{ mov.creditVes > 0 ? '+' : '-' }}Bs. {{ (mov.creditVes > 0 ? mov.creditVes : mov.debitVes) | number:'1.2-2' }}
                        </span>
                        <span
                          style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                          [style.background]="getVesStatusColor(mov.status)">
                          {{ getVesStatusLabel(mov.status) }}
                        </span>
                      </div>
                    </div>

                    <!-- Flecha -->
                    <mat-icon
                      style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;">
                      {{ expandedVesIndex === i ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </div>

                  <!-- Detalles expandibles -->
                  <div *ngIf="expandedVesIndex === i" style="border-top: 1px solid #f3f4f6;">
                    <div style="padding: 10px 14px 12px; overflow: hidden; min-width: 0;" class="sm:pl-16">
                      <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 2px;">
                        <div *ngIf="mov.creditVes > 0">
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Credito: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">Bs. {{ mov.creditVes | number:'1.2-2' }}</span>
                        </div>
                        <div *ngIf="mov.debitVes > 0">
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Debito: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">Bs. {{ mov.debitVes | number:'1.2-2' }}</span>
                        </div>
                        <div>
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Saldo: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">Bs. {{ mov.balanceVes | number:'1.2-2' }}</span>
                        </div>
                      </div>
                      <div *ngIf="mov.referenceId" style="margin-top: 4px; overflow: hidden;">
                        <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Ref: </span>
                        <span style="font-size: 0.78rem; font-weight: 600; color: #374151; font-family: monospace; word-break: break-all; overflow-wrap: anywhere;">{{ mov.referenceId }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty state -->
              <div *ngIf="!loadingVes && movimientosVes.length === 0"
                style="text-align: center; padding: 48px 20px;">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">receipt_long</mat-icon>
                <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay movimientos VES para mostrar</p>
              </div>
            </mat-tab>

            <!-- Tab USDT -->
            <mat-tab label="USDT">
              <div style="margin-top: 12px;">
                <!-- Loading -->
                <div *ngIf="loadingUsdt" style="text-align: center; padding: 48px 20px;">
                  <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
                  <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando movimientos USDT...</p>
                </div>

                <ng-container *ngIf="!loadingUsdt">

                  <!-- ══ Swaps pendientes de aprobación ══ -->
                  <ng-container *ngIf="usdtPendingSwaps.length > 0">
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b;">schedule</mat-icon>
                      <span style="font-weight: 700; font-size: 0.85rem; color: #92400e;">Pendientes de aprobaci&oacute;n</span>
                      <span style="background: #f59e0b; color: white; font-size: 0.65rem; font-weight: 700; padding: 1px 7px; border-radius: 10px;">
                        {{ usdtPendingSwaps.length }}
                      </span>
                    </div>
                    <div class="flex flex-col gap-3" style="margin-bottom: 16px;">
                      <div *ngFor="let swap of usdtPendingSwaps"
                        style="background: white; border-radius: 14px; border: 1px solid #fde68a; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">
                        <div style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; background: linear-gradient(135deg, #fffbeb, #fef3c7);">
                          <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; background: #fef3c7; align-items: center; justify-content: center; flex-shrink: 0;">
                            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #f59e0b; flex-shrink: 0;">swap_horiz</mat-icon>
                          </div>
                          <div style="flex: 1; min-width: 0;">
                            <div style="font-weight: 700; font-size: 0.85rem; color: #92400e;">{{ sanitizePendingSwapDescription(swap) }}</div>
                            <div style="font-size: 0.72rem; color: #b45309; margin-top: 2px;">{{ swap.createdAt | date:'medium' }}</div>
                            <div style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                              <span *ngIf="swap.debitVes > 0" style="font-weight: 700; font-size: 0.85rem; color: #dc2626;">
                                -${{ swap.debitVes | number:'1.2-2' }} USDT
                              </span>
                              <span style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700; background: #f59e0b;">
                                Pendiente
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- ══ Historial unificado (retiros + movimientos) ══ -->
                  <div *ngIf="unifiedUsdtMovements.length > 0"
                    style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">receipt_long</mat-icon>
                    <span style="font-weight: 700; font-size: 0.85rem; color: #1e5a3f;">Historial de movimientos</span>
                  </div>

                  <mat-paginator
                    *ngIf="totalMovimientosUsdt > 0"
                    [length]="totalMovimientosUsdt"
                    [pageSize]="pageSizeUsdt"
                    [pageSizeOptions]="[10, 20, 50]"
                    [pageIndex]="currentPageUsdt - 1"
                    (page)="onPageChangeUsdt($event)"
                    showFirstLastButtons
                    aria-label="Seleccionar pagina de movimientos USDT"
                    style="margin-bottom: 8px;">
                  </mat-paginator>

                  <div class="flex flex-col gap-3">
                    <div *ngFor="let mov of unifiedUsdtMovements; let i = index"
                      style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">

                      <!-- Header -->
                      <div (click)="expandedUsdtIndex = expandedUsdtIndex === i ? null : i"
                        style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer;"
                        [style.background]="expandedUsdtIndex === i ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

                        <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
                          [style.background]="mov.isCredit ? '#f0fdf4' : '#fef2f2'">
                          <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
                            [style.color]="mov.isCredit ? '#16a34a' : '#dc2626'">
                            {{ mov.isCredit ? 'south_west' : 'north_east' }}
                          </mat-icon>
                        </div>

                        <div style="flex: 1; min-width: 0;">
                          <div style="font-weight: 700; font-size: 0.85rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ mov.label }}
                          </div>
                          <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
                            {{ mov.date | date:'medium' }}
                          </div>
                          <div style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                            <span style="font-weight: 700; font-size: 0.85rem;"
                              [style.color]="mov.isCredit ? '#16a34a' : '#dc2626'">
                              {{ mov.isCredit ? '+' : '-' }}${{ mov.amount | number:'1.2-2' }}
                            </span>
                            <span style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                              [style.background]="getWithdrawalStatusColor(mov.status)">
                              {{ getWithdrawalStatusLabel(mov.status) }}
                            </span>
                          </div>
                        </div>

                        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;"
                          [style.transform]="expandedUsdtIndex === i ? 'rotate(180deg)' : 'rotate(0)'">
                          expand_more
                        </mat-icon>
                      </div>

                      <!-- Detalle expandible -->
                      <div *ngIf="expandedUsdtIndex === i" style="border-top: 1px solid #f3f4f6;">
                        <div style="padding: 10px 14px 12px; overflow: hidden; min-width: 0;" class="sm:pl-16">

                          <!-- Cardex details -->
                          <ng-container *ngIf="mov.source === 'cardex'">
                            <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 2px;">
                              <div *ngIf="mov.haber && mov.haber > 0">
                                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Cr&eacute;dito: </span>
                                <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">${{ mov.haber | number:'1.2-2' }}</span>
                              </div>
                              <div *ngIf="mov.debe && mov.debe > 0">
                                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">D&eacute;bito: </span>
                                <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">${{ mov.debe | number:'1.2-2' }}</span>
                              </div>
                              <div *ngIf="mov.saldo !== undefined">
                                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Saldo: </span>
                                <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">${{ mov.saldo | number:'1.2-2' }}</span>
                              </div>
                            </div>
                            <div *ngIf="mov.description" style="margin-top: 4px; font-size: 0.72rem; color: #374151; word-break: break-all; overflow-wrap: anywhere;">
                              {{ mov.description }}
                            </div>
                          </ng-container>

                          <!-- Withdrawal details -->
                          <ng-container *ngIf="mov.source === 'withdrawal'">
                            <div *ngIf="mov.walletAddress" style="margin-bottom: 4px; font-size: 0.75rem;">
                              <span style="font-weight: 600; color: #6b7280;">Wallet: </span>
                              <span style="color: #374151; font-family: monospace; word-break: break-all;">{{ mov.walletAddress }}</span>
                            </div>
                            <div *ngIf="mov.rejectionReason" style="margin-top: 4px; font-size: 0.72rem; color: #dc2626;">
                              <span style="font-weight: 600;">Motivo: </span>{{ mov.rejectionReason }}
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty state -->
                  <div *ngIf="unifiedUsdtMovements.length === 0 && usdtPendingSwaps.length === 0"
                    style="text-align: center; padding: 48px 20px;">
                    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">receipt_long</mat-icon>
                    <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay movimientos USDT para mostrar</p>
                  </div>

                </ng-container>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ng-container>

      <!-- Historial de Transacciones CLP (no VE) -->
      <ng-container *ngIf="tipoId !== 'VE'">
        <hr />
        <app-transactions></app-transactions>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="estadoValidacion === 0 && isCompany === 1 && !soloSolicitudDeDatos">
      <button type="button"
        routerLink="/wallet/client/company-registration"
        style="width: 100%; max-width: 360px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        Verifica tu cuenta
      </button>
      <span class="px-6 py-4 bg-aguacate-green/25 rounded-lg font-semibold"
        >Para procesar tus envíos es necesario que nos facilites algunos datos
        personales, esto con el objetivo de hacer tus envíos mas seguros y
        cumplir con las regulaciones locales.
      </span>
    </ng-container>
    <ng-container *ngIf="estadoValidacion === 1 && !soloSolicitudDeDatos">
      <span class="px-6 py-4 bg-aguacate-green/25 rounded-lg font-semibold"
        >Tu información está siendo validada por nuestro equipo, se te
        notificará a tu correo electrónico cuando el proceso finalice
      </span>
    </ng-container>

    <!-- Cliente en validación: todavía no puede operar, pero las tasas del
         riel propio salen de un endpoint público y son el mejor motivo para
         que termine el onboarding. Sólo las públicas: nada que pida token. -->
    <ng-container *ngIf="estadoValidacion === 1 && !soloSolicitudDeDatos">
      <app-home-rates [soloPublicas]="true"></app-home-rates>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="userRole === userEnum.aguacate_operator">
    <!-- <app-admin-rate></app-admin-rate>
    <app-rate-update-type></app-rate-update-type> -->
    <app-main-rates></app-main-rates>
  </ng-container>
</div>
